<template>
  <div class="page-wraper">
    <router-view></router-view>
    <MenuBar/>
    <CallModal/>
    <Sidebar/>
  </div>
</template>

<script setup>
import MenuBar from './partials/menuBar'
import {onMounted} from "vue";
import CallModal from "@/views/master/layouts/partials/callModal";
import Sidebar from "@/views/master/layouts/partials/sidebar";

onMounted(() => {

})


</script>

<style>
.page-wraper{
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

</style>